import React from 'react';
import { MapPinIcon } from 'lucide-react';
const cities = ['Scottsdale', 'Chandler', 'Tempe', 'Mesa', 'Gilbert', 'Phoenix', 'Casa Grande', 'Sun Lakes', 'Surprise', 'San Tan Valley', 'Queen Creek', 'Fountain Hills', 'Buckeye', 'Apache Junction', 'Goodyear', 'Paradise Valley'];
export function ServiceAreaSection() {
  return <section id="service-area" className="relative py-20 md:py-32 px-6 bg-[url('https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=1920&q=80')] bg-scroll md:bg-fixed bg-cover bg-center" data-id="element-152">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-navy/80" data-id="element-153" />

      <div className="relative z-10 container mx-auto max-w-6xl text-center" data-id="element-154">
        <span className="text-brand-red uppercase text-sm font-bold tracking-wider block mb-3" data-id="element-155">
          Service Area
        </span>
        <h2 className="text-white text-3xl md:text-5xl font-bold uppercase tracking-wide mb-6" data-id="element-156">
          Proudly Serving the Greater Phoenix Area
        </h2>
        <p className="text-gray-300 text-lg md:text-xl max-w-3xl mx-auto mb-12" data-id="element-157">
          From residential pools to water features, our services are available
          to communities throughout Arizona.
        </p>

        {/* City Pills Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 mb-16" data-id="element-158">
          {cities.map(city => <div key={city} className="flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 text-white px-4 py-3 text-sm md:text-base font-medium backdrop-blur-sm hover:bg-white/20 transition-colors" data-id="element-159">
              <MapPinIcon className="w-4 h-4 text-brand-red" data-id="element-160" />
              {city}
            </div>)}
        </div>

        <a href="#contact" className="inline-block bg-brand-red hover:bg-brand-red-dark text-white rounded-lg px-10 py-4 text-lg font-bold transition-all duration-300 shadow-lg w-full sm:w-auto" data-id="element-161">
          Check Availability
        </a>
      </div>
    </section>;
}